
export class UtbyteStatusKod {
// eslint-disable-next-line sonarjs/public-static-readonly
    static OK = "OK";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Varning = "Varning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Error = "Error";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static ValidationError = "ValidationError";
}
